module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/6358e60235b1d4f5ab82744ac814cec7.png";